<template>
  <div class="tag-selection">
    <h4 class="tag-selection-title">
      {{ $t('customers.settings.availableTags') }}
    </h4>
    <div class="tag-list">
      <el-button
        v-for="tag in availableTags"
        :key="tag.key"
        size="small"
        type="primary"
        plain
        class="tag-button"
        @click="$emit('tag-selected', tag.key)"
      >
        {{ tag.label }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagSelection',
  props: {
    availableTags: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-selection {
  margin: 1.5rem 0;
}

.tag-selection-title {
  margin: 0 0 1rem 0;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
</style>
